export const environment = {
  production: true,
  apiUrl: 'https://api.cloud.infinitemd.com',
  domainUrl: 'https://cloud.infinitemd.com',
  bucketName: 'imd-prod-uploads',
  socketUrl: 'https://api.cloud.infinitemd.com',
  REOPhaseDeploymentTime: '2022-07-31T00:00:00.000Z'
};
